"use client";

import { SearchIcon } from "lucide-react";
import { TextEffect } from "@/components/ui/motion";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { Spotlight } from "@/components/motion-primitives/spotlight";

function isMacOS() {
  return /(macintosh|macintel|macppc|mac68k|macos)/i.test(
    window.navigator.userAgent.toLowerCase(),
  );
}

export const SearchTriggerLarge = ({
  placeholder,
}: {
  placeholder: string;
}) => {
  const [shortcutKey, setShortcutKey] = useState<string>("");
  useEffect(() => {
    if (window.innerWidth > 768) {
      setShortcutKey(isMacOS() ? "⌥+R" : "Alt+R");
    }
  }, []);

  return (
    <div className={cn("bg-input relative h-[50px] w-full rounded-xl p-[1px]")}>
      <Spotlight
        className="from-remedium-blue via-remedium-blue/90 to-remedium-blue/80 blur-3xl"
        size={124}
      />
      <div className="group relative inline-flex h-[48px] w-full cursor-pointer items-center justify-between gap-2 overflow-hidden rounded-xl bg-white px-[13px] py-3.5 transition-all hover:cursor-pointer">
        <div className="inline-flex h-5 items-center justify-start gap-2 rounded-lg">
          <div className={"group-hover:text-remedium-blue"}>
            <SearchIcon size={"16px"} className={"transition-all"} />
          </div>
          <div className="inline-flex h-5 flex-col items-start justify-center rounded-lg">
            <div className="group-hover:text-remedium-blue text-sm leading-tight font-normal text-nowrap text-zinc-950 transition-all">
              <TextEffect>{placeholder}</TextEffect>
            </div>
          </div>
        </div>
        {shortcutKey !== "" && (
          <div className="hidden h-5 flex-col items-start justify-center rounded-lg md:inline-flex">
            <div className="text-sm leading-tight font-normal text-zinc-500">
              {shortcutKey}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
